import i18next from "i18next";
import { Badge, BadgesList, Icon, Text, Wrapper } from "./style";

const SecurityBadges = () => {
  const { t } = i18next;

  return (
    <Wrapper>
      <Icon>🔒</Icon>
      <Text>{t("secure_payment_message")}</Text>
      <BadgesList>
        <Badge>SSL {t("secure")}</Badge>
        <Badge>PCI {t("compliant")}</Badge>
      </BadgesList>
    </Wrapper>
  );
};

export default SecurityBadges;

